import type React from 'react';
import { useEffect, useState } from 'react';

import { ButtonGroup, Label, ToggleButton } from '@zillow/constellation';

import PropertyType_v1 from './PropertyType_v1';
import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: Section) => void;
};

function PropertyType_v2({ section, setSectionValues, setSection }: Props): JSX.Element {
  useEffect(() => {
    section.showMandate = false;
    setSection(section);
  }, []);

  const [fourUnitsOrFewerClicked, setFourUnitsOrFewerClicked] = useState(false);
  const [fiveUnitsOrMoreClicked, setFiveUnitsOrMoreClicked] = useState(false);

  function onFourUnitsOrFewer(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setFourUnitsOrFewerClicked(true);
    setFiveUnitsOrMoreClicked(false);

    section.showMandate = true;
    setSection(section);
  }

  function onFiveUnitsOrMore(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setFourUnitsOrFewerClicked(false);
    setFiveUnitsOrMoreClicked(true);

    section.showMandate = false;
    setSection(section);
  }

  const isMultiFamily = section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY);

  return (
    <PropertyType_v1 {...{ section, setSectionValues, setSection }}>
      {isMultiFamily && (
        <>
          <Label>How many units are in the property?</Label>
          <ButtonGroup
            direction="column"
            fluid
            marginTop="xs"
            conjoined
            marginBottom={fourUnitsOrFewerClicked ? 'md' : ''}
            aria-label="number-of-units"
          >
            <ToggleButton
              data-test="property-type-v2-4-units-or-fewer-btn"
              pressed={fourUnitsOrFewerClicked}
              onClick={onFourUnitsOrFewer}
            >
              4 units or fewer
            </ToggleButton>
            <ToggleButton
              data-test="property-type-v2-5-units-or-more-btn"
              pressed={fiveUnitsOrMoreClicked}
              onClick={onFiveUnitsOrMore}
            >
              5 units or more
            </ToggleButton>
          </ButtonGroup>
        </>
      )}
    </PropertyType_v1>
  );
}

export default PropertyType_v2;
